
import React from 'react';
import { TableButtons } from "./table-buttons";
import {deep_copy, string_cmp} from "../../../lib/js-utils";
import {OfferingsTable} from "./offeringsTable";
import {Spinner, VIMEO_ICON_TYPE, VimeoIcon} from "../../funcs/utils";
import {Search} from "./search";
import {PurchaseModal} from "./purchase-modal";
import {getRGB, multWhite} from "../../../lib/color";
import { sprintf } from "sprintf-js";
import {loadAllOfferings, purchaseNoLoginRequest, purchaseRequest} from "./actions";
import {StateRestrictedModal} from "./state-restricted-modal";
import {dollarToString} from "../../../lib/currency-utils";
import {DEVICE_WIDTH} from "../../../lib/constants";
import {HEADER_SORT} from "./common";
import {PurchaseNoLoginModal} from "./purchase-no-login-modal";
import {RATES_LINKS} from "./rates_links";

const DISCLOSURE_URL = "https://www.cdexplorer.com/_files/ugd/657db2_c9d715ef3b2c4a39b366685c1cb077c2.pdf";

const date_to_yymmdd = (date) => {
  const [ mm, dd, yyyy ] = date.split("/");
  const month = parseInt(mm, 10);
  const day = parseInt(dd, 10);
  return sprintf("%s-%02d-%02d", yyyy, month, day);
}

class CurrentOfferings extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      button_select_over: null,
      search: "",
      show_purchase_modal: false,
      purchase_amt: "",
      dialog_error: "",
      is_purchasing: false,
      is_loading: false,
      sorted_items: [],
      firm_name: "",
      last_name: "",
      blank_amt: false,
      blank_firm: false,
      blank_name: false,
    }
  }

  componentDidMount() {
    this.handleLoading(true);
    this.handlePurchaseItem();
  }

  componentDidUpdate() {
    this.handleLoading();
  }

  handlePurchaseItem = () => {
    const table = this.props.args.table;
    const cusip = this.props.args.cusip;
    const amt_usd = this.props.args.amt_usd
      && parseInt(this.props.args.amt_usd, 10);

    if (!cusip || !amt_usd || !table) {
      return;
    }

    const items = this.props.cdOffering.tables[table]
      && this.props.cdOffering.tables[table].items;
    if (!items) {
      return;
    }

    const item = items.find(item => item.CUSIP === cusip);
    if (item) {
      this.setState({
        show_purchase_modal: item,
        purchase_amt: sprintf("%d", amt_usd),
      })
    }
  }

  handleLoading = (on_mount) => {
    const table = this.props.args.table;

    if (!table) {
      console.log("no table");
      return;
    }

    const offering = this.props.cdOffering;

    if (this.state.is_loading) {
      return;
    }
    if (offering.tables[table]) {
      if (on_mount && this.state.sorted_items.length === 0) {
        this.sort_items(table, "Term", HEADER_SORT.INCR);
      }
      return;
    }

    // Load all offerings
    const offerings =
      (this.props.app.wlf.ui && this.props.app.wlf.ui.offerings) || [];
    if (offerings.length > 0) {
      this.setState({is_loading: true});
      loadAllOfferings(offerings)
        .then(res => {
          if (res.status === "ERROR") {
            console.log("Error", res);
          } else {
            this.props.setOfferings(res.payload);
            this.sort_items(this.props.args.table, "Term", HEADER_SORT.INCR);
          }
          this.setState({is_loading: false});
        })
    }
  }

  updateSearch = (search_str) => {
    this.setState({
      search: search_str,
    }, () => {
      this.sort_items(
        this.props.args.table,
        this.state.header_sort.column,
        this.state.header_sort.dir);
    })
  }

  sort_items = (table_name, col, dir) => {
    // Do search if enabled
    const is_logged_in = this.props.user.token;
    const table = this.props.cdOffering.tables[table_name];
    if (!table) {
      return;
    }
    let col_index = table.columns.indexOf(col);
    if (!is_logged_in) {
      col_index--;
    }
    const search_str = this.state.search;
    const term_prop = "Term in Months";
    if (!table) {
      this.setState({ sorted_items: []});
      return;
    }

    const curr_items = [];
    
    for(let i=0; i < table.items.length; i++) {
      if (search_str && !table.index[i].includes(search_str)) {
        continue;
      }
      curr_items.push(table.items[i]);
    }

    const sort_func = (item_a, item_b) => {
      let val;
      if (col === "Term") {
        val = parseFloat(item_a[term_prop])
          - parseFloat(item_b[term_prop]);
        if (dir === HEADER_SORT.DECR) {
          val *= -1;
        }
        return val;
      }

      let text_a = item_a[col];
      let text_b = item_b[col];
      if (col === "Maturity" || col === "Settle Date") {
        text_a = date_to_yymmdd(text_a);
        text_b = date_to_yymmdd(text_b);
      }
      val = string_cmp(text_a, text_b);
      if (dir === HEADER_SORT.DECR) {
        val *= -1;
      }
      return val;
    }
    
    curr_items.sort(sort_func);
    this.setState({
      sorted_items: curr_items,
      header_sort: {
        index: col_index,
        dir,
        column: col,
      }
    });

  }

  is_small_layout = () => {
    return this.props.app.width <= DEVICE_WIDTH.medium;
  }

  render_header = () => {

    const is_small = this.is_small_layout();
    const no_video_link = this.props.app.wlf.ui && this.props.app.wlf.ui.offerings_no_video_link;
    const header_style = {
      fontSize: is_small ? "1.5rem" : "4rem",
      fontWeight: "600",
      color: "#000",
      marginLeft: is_small ? "2rem" : "10rem",
    }

    const text = is_small
      ? "Current Offerings are subject to availability"
      : "Current Offerings";
    const container_style = {
      display: "flex",
      alignItems: "center",
      marginTop: is_small ? "2rem" : "4rem",
    }
    const vimeo_id = "844028260";
    const img_style = {
      transform: "translate(0, 0.2rem) scale(1.1, 1)",
    }
    return (
      <div>
        <div style={container_style}>
          <div style={header_style}>
            { text }
          </div>
          <div style={{ width: "2rem"}}/>
          <div>
            {!is_small && !no_video_link && <VimeoIcon
              state={this.state}
              component={this}
              icon={VIMEO_ICON_TYPE.VIDEO_ICON}
              video_id={vimeo_id}
              img_style={img_style}
              id={"vimeo_" + vimeo_id}/> }
          </div>
        </div>
        { is_small && <div style={{height: "2rem"}}/> }
      </div>
    )
  }

  on_row_button_click = id => {

    if (id === "disclosure") {
      window.open(DISCLOSURE_URL, '_blank', 'noreferrer');
    } else if (id === "__search") {
      // do nothing
    } else {
      const args = deep_copy(this.props.args);
      args.table = id;
      this.props.navigatePath(this.props.path, args);
    }

  }

  render_buttons = () => {
    const do_small = this.is_small_layout();
    const left_buttons = [
      {
        id: "NON_CALLABLE_CDS",
        label: "Non-Callable CDs",
      },
      /*{
        id: "CALLABLE",
        label: "Callable CDs",
      }*/
    ];
    const style = {
      margin: "2px",
      padding: "0.5rem 1rem",
      width: "12rem",
      cursor: "pointer",
    }

    const container_style = {
      display: "flex",
      alignItems: "center",
    }

    if (!this.props.no_margins) {
      container_style.margin = do_small
        ? "0 2rem" : "0 10rem";
    }

    const disclosure_over = this.state.button_select_over === "disclosure";

    const disclosure_bg = getRGB(
      multWhite(
        this.props.client.color.sign_on_button,
        disclosure_over ? 0.4: 0));

    const right_buttons = [
      {
        id: "disclosure",
        label: "Disclosure",
        style: {
          backgroundColor: disclosure_bg,
          color: "black",
          border: "solid 1px black",
          fontWeight: "bold",
          fontSize: "1.1rem",
        }
      },
      {
        id: "__search",
        label: (<Search component={this}/>)
      }
    ]

    const no_table_buttons = true;
    const avail_style = {
      paddingRight: "1rem",
      fontSize: "1.2rem",
      fontWeight: "bold",
    }
    const avail_disc = (
      <div style={avail_style}>
        Offerings are subject to availability
      </div>
    );
    const is_small = this.is_small_layout();

    return (
      <div style={container_style}>
        {!no_table_buttons && <TableButtons
          over={this.state.button_select_over}
          current={this.props.args.table}
          button_list={left_buttons}
          on_click={this.on_row_button_click}
          component={this}
          button_style={style}/> }
        <div style={{flex: "1"}}/>
        { !is_small && avail_disc }
        <TableButtons
          component={this}
          button_list={right_buttons}
          on_click={this.on_row_button_click}
          button_style={style}/>
      </div>
    );
  }

  onMouseRowEvent = (index, enter) => {
    index -= 1;
    if (enter) {
      this.setState({
        selected_row: index,
      })
    } else if (index === this.state.selected_row) {
      this.setState({
        selected_row: -1,
      })
    }
  }

  onMouseRowClick = () => {}

  onBuyClick = (index) => {
    const item = this.state.sorted_items[index];
    this.setState({
      show_purchase_modal: item,
    })
  }

  onHidePurchaseModal = () => {
    this.setState({
      show_purchase_modal: null,
      dialog_error: "",
      purchase_amt: "",
    });
    const args = deep_copy(this.props.args);
    delete args.purchase_item;
    delete args.cusip;
    delete args.amt_usd;
    this.props.navigatePath(this.props.path, args);
  }

  onPurchaseNoLoginClick = cusip => {
    this.setState({ is_purchasing: true});
    purchaseNoLoginRequest(
      this.props.app.wlf.id,
      this.state.last_name,
      this.state.firm_name,
      parseFloat(this.state.purchase_amt),
      cusip)
      .then(res => {
        this.setState({
          is_purchasing: false,
          show_purchase_modal: null,
        });
        if (res.status === "ERROR") {
          console.log(res);
        }
        console.log("got", res);
      })
  }

  onPurchaseDialogClick = (id, cusip) => {
    const purchase = {
      table: this.props.args.table,
      cusip,
      amt: this.state.purchase_amt,
      op: id,
    }

    if (id === "purchase") {
      this.setState({ is_purchasing: true });
      purchaseRequest(
        this.props.user.token,
        cusip, this.state.purchase_amt,
        this.props.args.acct_index)
        .then(item => {
          this.setState({ is_purchasing: false });
          const username = this.props.user.username;
          this.props.addUserSecurityItems(username, [ item ] );
          const args = deep_copy(this.props.args);
          delete args.cusip;
          delete args.table;
          delete args.amt_usd;
          if (!this.props.no_nav_on_purchase) {
            this.props.navigatePath("/user", args);
          }
          this.setState({
            show_purchase_modal: null,
            dialog_error: "",
            purchase_amt: "",
          })
        })
    } else if (id === "sign_in") {
      const encoded = new Buffer(JSON.stringify(purchase)).toString('base64');
      const args = {
        purchase_item: encoded,
      }
      this.props.navigatePath("/login", args);
    } else if (id === "create_account") {
      const encoded = new Buffer(JSON.stringify(purchase)).toString('base64');
      const args = {
        purchase_item: encoded,
      }
      this.props.navigatePath("/new_account", args);
    }
  }

  render_table = () => {

    const table_name = this.props.args.table;
    const _table = this.props.cdOffering.tables[table_name];
    const table = _table && deep_copy(_table);
    const is_logged_in = this.props.user.token;
    const loading = this.state.is_loading;
    const has_table = !!table;
    const is_small = this.is_small_layout();

    const spinner = (
      <div style={{margin: "4rem"}}>
        <Spinner size={"2rem"}/>
      </div>);
    const container_style = {}
    if (!this.props.no_margins && !is_small) {
      container_style.margin = "0 10rem";
    }
    if (is_small) {
      container_style.overflowX = "auto";
    }

    if (!is_logged_in && table) {
      table.columns.shift();
    }

    let date_str = "";
    if (table && table.updated) {
      const date = new Date(table.updated * 1000);
      date_str = sprintf("Updated %02d/%02d/%04d %02d:%02d:%02d",
        date.getMonth() + 1, date.getDate(), date.getFullYear(),
        date.getHours(), date.getMinutes(), date.getSeconds());
    }

    const table_style = {
      width: "100%",
      tableLayout: is_small ? "auto" : "fixed",
    }
    return (
      <div align={"center"} style={container_style}>
        { has_table &&
        <OfferingsTable
          tableStyle={table_style}
          header_color={this.props.client.color.sign_on_button}
          table={table}
          items={this.state.sorted_items}
          selected_row={this.state.selected_row}
          search={this.state.search}
          component={this}/>
        }
        { loading && spinner }
        <div style={{height: "2rem"}}/>
        <div align={"left"}>
          { date_str }
        </div>
        <div style={{height: "5rem"}}/>
      </div>
    )
  }

  get_state_restrictions = item => {
    if (!item) {
      return [];
    }
    const prop = "State Restrictions";
    if (prop in item) {
      return item[prop].split(",").map(item => item.trim());
    }
    return [];
  }

  renderAvailableCash = () => {
    const component = this.props.component;
    const draw_down = component.get_draw_down();
    const deposits_usd = component.get_deposits();
    const current_cash = component.get_cash();
    const available_usd = deposits_usd - draw_down + current_cash;
    const green_style = {
      color: "#3A3",
    }
    const red_style = {
      color: "#A33"
    }
    const title_style = {
      fontSize: "1.2rem",
      fontWeight: "bold",
    }

    return (
      <div>
        <div style={{height: "2rem"}}/>
        <div style={title_style}>You currently have:</div>
        <div style={green_style}>
          + {dollarToString(deposits_usd)} in deposits
        </div>
        <div style={red_style}>
          - {dollarToString(draw_down)} in purchases
        </div>
        <div>
          {dollarToString(available_usd)} available to invest
        </div>
      </div>
    )
  }

  dump_best_rates = () => {
    const container_style = {
      marginTop: "3rem",
      display: "flex",
      overflowX: "auto",
    }
    const item_style = {
      flex: "1",
      minWidth: "12rem",
      maxHeight: "90px",
    }
    const items = RATES_LINKS.map((item, index) => {
      return (
        <div style={item_style} key={index}>
          <iframe
            title={sprintf("rate_%d", index)}
            width={198}
            height={87} seamless frameBorder="0" scrolling="no"
            src={item.link}></iframe>
        </div>
      )
    });
    return (
      <div style={container_style}>
        { items }
      </div>
    )
  }

  render = () => {
    const logged_in = !!(this.props.user.token || this.props.user.onboarding_token);
    const wlf = this.props.app.wlf;
    const purchse_no_login = wlf.ui && wlf.ui.offering_purchase_no_login;
    const item = this.state.show_purchase_modal;
    const no_header = this.props.no_header;
    let draw_down = 0.;
    let deposits = 0.;
    let cash = 0.;
    let state;
    let state_restrictions = [];
    let restricted_cusip = false;
    let modal;

    if (this.props.component) {
      draw_down = this.props.component.get_draw_down();
      deposits = this.props.component.get_deposits();
      cash = this.props.component.get_cash();
      state = this.props.component.get_address_state();
      state_restrictions = this.get_state_restrictions(item);
      restricted_cusip = state_restrictions.includes(state);
    }

    const available_cash = cash + deposits - draw_down;
    if (restricted_cusip) {
      modal = (
        <StateRestrictedModal
          item={item}
          component={this}
          restricted_states={state_restrictions}/>);
    } else if (item) {
      if (!logged_in && purchse_no_login) {
        modal = (
          <PurchaseNoLoginModal
            item={item}
            component={this}
            available_cash={available_cash}
            address_state={state}
            is_purchasing={this.state.is_purchasing}
            client={this.props.client}/>);
      } else {
        modal = (
          <PurchaseModal
            item={item}
            component={this}
            logged_in={logged_in}
            available_cash={available_cash}
            address_state={state}
            is_purchasing={this.state.is_purchasing}
            client={this.props.client}/>);
      }
    }

    return (
      <div>
        { this.props.do_available_cash && this.renderAvailableCash() }
        { this.dump_best_rates() }
        { !no_header && this.render_header() }
        { this.render_buttons() }
        { this.render_table() }
        { modal }
      </div>
    )
  }
}

export { CurrentOfferings };